// Auto-generated index of Bootstrap3 components
import BS_Affix from "./Bootstrap3_Components/BS_Affix.jsx";
import BS_Alerts from "./Bootstrap3_Components/BS_Alerts.jsx";
import BS_Badges_Labels from "./Bootstrap3_Components/BS_Badges_Labels.jsx";
import BS_ButtonGroups from "./Bootstrap3_Components/BS_ButtonGroups.jsx";
import BS_Buttons from "./Bootstrap3_Components/BS_Buttons.jsx";
import BS_Carousel from "./Bootstrap3_Components/BS_Carousel.jsx";
import BS_Certificate from "./Bootstrap3_Components/BS_Certificate.jsx";
import BS_Collapse from "./Bootstrap3_Components/BS_Collapse.jsx";
import BS_CSS_AllClasses from "./Bootstrap3_Components/BS_CSS_AllClasses.jsx";
import BS_CSS_Buttons from "./Bootstrap3_Components/BS_CSS_Buttons.jsx";
import BS_CSS_Dropdowns from "./Bootstrap3_Components/BS_CSS_Dropdowns.jsx";
import BS_CSS_Forms from "./Bootstrap3_Components/BS_CSS_Forms.jsx";
import BS_CSS_Glyphicons from "./Bootstrap3_Components/BS_CSS_Glyphicons.jsx";
import BS_CSS_Helpers from "./Bootstrap3_Components/BS_CSS_Helpers.jsx";
import BS_CSS_Images from "./Bootstrap3_Components/BS_CSS_Images.jsx";
import BS_CSS_Navs from "./Bootstrap3_Components/BS_CSS_Navs.jsx";
import BS_CSS_Tables from "./Bootstrap3_Components/BS_CSS_Tables.jsx";
import BS_CSS_Typography from "./Bootstrap3_Components/BS_CSS_Typography.jsx";
import BS_Dropdowns from "./Bootstrap3_Components/BS_Dropdowns.jsx";
import BS_Editor from "./Bootstrap3_Components/BS_Editor.jsx";
import BS_Examples from "./Bootstrap3_Components/BS_Examples.jsx";
import BS_Exercises from "./Bootstrap3_Components/BS_Exercises.jsx";
import BS_Filters from "./Bootstrap3_Components/BS_Filters.jsx";
import BS_Forms from "./Bootstrap3_Components/BS_Forms.jsx";
import BS_GetStarted from "./Bootstrap3_Components/BS_GetStarted.jsx";
import BS_Glyphicons from "./Bootstrap3_Components/BS_Glyphicons.jsx";
import BS_GridBasic from "./Bootstrap3_Components/BS_GridBasic.jsx";
import BS_GridExamples from "./Bootstrap3_Components/BS_GridExamples.jsx";
import BS_GridLarge from "./Bootstrap3_Components/BS_GridLarge.jsx";
import BS_GridMedium from "./Bootstrap3_Components/BS_GridMedium.jsx";
import BS_GridSmall from "./Bootstrap3_Components/BS_GridSmall.jsx";
import BS_GridSystem from "./Bootstrap3_Components/BS_GridSystem.jsx";
import BS_Home from "./Bootstrap3_Components/BS_Home.jsx";
import BS_Images from "./Bootstrap3_Components/BS_Images.jsx";
import BS_Inputs from "./Bootstrap3_Components/BS_Inputs.jsx";
import BS_Inputs2 from "./Bootstrap3_Components/BS_Inputs2.jsx";
import BS_InputSizing from "./Bootstrap3_Components/BS_InputSizing.jsx";
import BS_InterviewPrep from "./Bootstrap3_Components/BS_InterviewPrep.jsx";
import BS_JS_Affix from "./Bootstrap3_Components/BS_JS_Affix.jsx";
import BS_JS_Alert from "./Bootstrap3_Components/BS_JS_Alert.jsx";
import BS_JS_Button from "./Bootstrap3_Components/BS_JS_Button.jsx";
import BS_JS_Carousel from "./Bootstrap3_Components/BS_JS_Carousel.jsx";
import BS_JS_Collapse from "./Bootstrap3_Components/BS_JS_Collapse.jsx";
import BS_JS_Dropdown from "./Bootstrap3_Components/BS_JS_Dropdown.jsx";
import BS_JS_Modal from "./Bootstrap3_Components/BS_JS_Modal.jsx";
import BS_JS_Popover from "./Bootstrap3_Components/BS_JS_Popover.jsx";
import BS_JS_Scrollspy from "./Bootstrap3_Components/BS_JS_Scrollspy.jsx";
import BS_JS_Tab from "./Bootstrap3_Components/BS_JS_Tab.jsx";
import BS_JS_Tooltip from "./Bootstrap3_Components/BS_JS_Tooltip.jsx";
import BS_Jumbotron from "./Bootstrap3_Components/BS_Jumbotron.jsx";
import BS_ListGroups from "./Bootstrap3_Components/BS_ListGroups.jsx";
import BS_MediaObjects from "./Bootstrap3_Components/BS_MediaObjects.jsx";
import BS_Modal from "./Bootstrap3_Components/BS_Modal.jsx";
import BS_Navbar from "./Bootstrap3_Components/BS_Navbar.jsx";
import BS_Pager from "./Bootstrap3_Components/BS_Pager.jsx";
import BS_Pagination from "./Bootstrap3_Components/BS_Pagination.jsx";
import BS_Panels from "./Bootstrap3_Components/BS_Panels.jsx";
import BS_Popover from "./Bootstrap3_Components/BS_Popover.jsx";
import BS_ProgressBars from "./Bootstrap3_Components/BS_ProgressBars.jsx";
import BS_Quiz from "./Bootstrap3_Components/BS_Quiz.jsx";
import BS_Scrollspy from "./Bootstrap3_Components/BS_Scrollspy.jsx";
import BS_StackedHorizontal from "./Bootstrap3_Components/BS_StackedHorizontal.jsx";
import BS_Tables from "./Bootstrap3_Components/BS_Tables.jsx";
import BS_TabsPills from "./Bootstrap3_Components/BS_TabsPills.jsx";
import BS_Templates from "./Bootstrap3_Components/BS_Templates.jsx";
import BS_ThemeBand from "./Bootstrap3_Components/BS_ThemeBand.jsx";
import BS_ThemeCompany from "./Bootstrap3_Components/BS_ThemeCompany.jsx";
import BS_ThemeSimplyMe from "./Bootstrap3_Components/BS_ThemeSimplyMe.jsx";
import BS_Tooltip from "./Bootstrap3_Components/BS_Tooltip.jsx";
import BS_Typography from "./Bootstrap3_Components/BS_Typography.jsx";
import BS_Wells from "./Bootstrap3_Components/BS_Wells.jsx";

const bootstrap3ComponentsMap = {
  "<BS_Affix />": BS_Affix,
  "<BS_Alerts />": BS_Alerts,
  "<BS_Badges_Labels />": BS_Badges_Labels,
  "<BS_ButtonGroups />": BS_ButtonGroups,
  "<BS_Buttons />": BS_Buttons,
  "<BS_Carousel />": BS_Carousel,
  "<BS_Certificate />": BS_Certificate,
  "<BS_Collapse />": BS_Collapse,
  "<BS_CSS_AllClasses />": BS_CSS_AllClasses,
  "<BS_CSS_Buttons />": BS_CSS_Buttons,
  "<BS_CSS_Dropdowns />": BS_CSS_Dropdowns,
  "<BS_CSS_Forms />": BS_CSS_Forms,
  "<BS_CSS_Glyphicons />": BS_CSS_Glyphicons,
  "<BS_CSS_Helpers />": BS_CSS_Helpers,
  "<BS_CSS_Images />": BS_CSS_Images,
  "<BS_CSS_Navs />": BS_CSS_Navs,
  "<BS_CSS_Tables />": BS_CSS_Tables,
  "<BS_CSS_Typography />": BS_CSS_Typography,
  "<BS_Dropdowns />": BS_Dropdowns,
  "<BS_Editor />": BS_Editor,
  "<BS_Examples />": BS_Examples,
  "<BS_Exercises />": BS_Exercises,
  "<BS_Filters />": BS_Filters,
  "<BS_Forms />": BS_Forms,
  "<BS_GetStarted />": BS_GetStarted,
  "<BS_Glyphicons />": BS_Glyphicons,
  "<BS_GridBasic />": BS_GridBasic,
  "<BS_GridExamples />": BS_GridExamples,
  "<BS_GridLarge />": BS_GridLarge,
  "<BS_GridMedium />": BS_GridMedium,
  "<BS_GridSmall />": BS_GridSmall,
  "<BS_GridSystem />": BS_GridSystem,
  "<BS_Home />": BS_Home,
  "<BS_Images />": BS_Images,
  "<BS_Inputs />": BS_Inputs,
  "<BS_Inputs2 />": BS_Inputs2,
  "<BS_InputSizing />": BS_InputSizing,
  "<BS_InterviewPrep />": BS_InterviewPrep,
  "<BS_JS_Affix />": BS_JS_Affix,
  "<BS_JS_Alert />": BS_JS_Alert,
  "<BS_JS_Button />": BS_JS_Button,
  "<BS_JS_Carousel />": BS_JS_Carousel,
  "<BS_JS_Collapse />": BS_JS_Collapse,
  "<BS_JS_Dropdown />": BS_JS_Dropdown,
  "<BS_JS_Modal />": BS_JS_Modal,
  "<BS_JS_Popover />": BS_JS_Popover,
  "<BS_JS_Scrollspy />": BS_JS_Scrollspy,
  "<BS_JS_Tab />": BS_JS_Tab,
  "<BS_JS_Tooltip />": BS_JS_Tooltip,
  "<BS_Jumbotron />": BS_Jumbotron,
  "<BS_ListGroups />": BS_ListGroups,
  "<BS_MediaObjects />": BS_MediaObjects,
  "<BS_Modal />": BS_Modal,
  "<BS_Navbar />": BS_Navbar,
  "<BS_Pager />": BS_Pager,
  "<BS_Pagination />": BS_Pagination,
  "<BS_Panels />": BS_Panels,
  "<BS_Popover />": BS_Popover,
  "<BS_ProgressBars />": BS_ProgressBars,
  "<BS_Quiz />": BS_Quiz,
  "<BS_Scrollspy />": BS_Scrollspy,
  "<BS_StackedHorizontal />": BS_StackedHorizontal,
  "<BS_Tables />": BS_Tables,
  "<BS_TabsPills />": BS_TabsPills,
  "<BS_Templates />": BS_Templates,
  "<BS_ThemeBand />": BS_ThemeBand,
  "<BS_ThemeCompany />": BS_ThemeCompany,
  "<BS_ThemeSimplyMe />": BS_ThemeSimplyMe,
  "<BS_Tooltip />": BS_Tooltip,
  "<BS_Typography />": BS_Typography,
  "<BS_Wells />": BS_Wells,
};

export default bootstrap3ComponentsMap;
